import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import {formValueSelector} from "redux-form/immutable";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./ShippingAddressForm";
import {GET_SHIPPING_COUNTRIES_FOR_ACCOUNT} from "../../queries/customers";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelAddShippingAddress} from "../../actions/AccountApiActions";
import {fromJS, List} from "immutable";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";
import {getUSStates, getCanadaProvinces, isUS, isCanada} from "../../lib/CountriesAndStates";
import MessageBus from "../../lib/MessageBus";
import {hasStateProvince} from "../../lib/AddressRules";
import {validateShippingAddress} from "../../lib/AddressValidation";

function validateForm(values, props) {
  return validateShippingAddress(values).toJS();
}

class AddShippingAddressFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("accountId", this.props.accountId);
    return this.props.addShippingAddress(updatedValues.toJS())
      .then((response) => {
        if (response.data.addShippingAddress.errors.length <= 0) {
          MessageBus.publish("shipping", "address_added", {
            addressId: response.data.addShippingAddress.addressId
          })
          this.props.cancelAddShippingAddress();
        } else {
          let errors = createValidationErrors(response.data.addShippingAddress.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelAddShippingAddress();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let countries = fromJS(data.availableCountriesForAccount);
    let stateProvinces = List([]);
    if (this.props.showUSStates) stateProvinces = getUSStates();
    if (this.props.showCanadaProvinces) stateProvinces = getCanadaProvinces();

    return (
      <Form
        errors={this.state.errors}
        validate={validateForm}
        countries={countries}
        stateProvinces={stateProvinces}
        showAttentionName={true}
        showPhoneNr={true}
        showEmail={true}
        showStateProvince={this.props.showStateProvince}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const ADD_SHIPPING_ADDRESS = gql`
  mutation addShippingAddress($data: ShippingAddressInput!) {
    addShippingAddress(input: $data) {
      addressId
      errors { key message }
    }
  }
`;

const withAddressQuery = compose(
  graphql(GET_SHIPPING_COUNTRIES_FOR_ACCOUNT, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        accountId: props.accountId
      }
    })
  }),
  graphql(ADD_SHIPPING_ADDRESS, {
    props: ({ mutate }) => ({
      addShippingAddress: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

const AddShippingAddressFormContainerWithData = withAddressQuery(AddShippingAddressFormContainer);

const selector = formValueSelector("ShippingAddressForm");
function mapStateToProps(state, ownProps) {
  return {
    showUSStates: isUS(selector(state, "addressCountryCode")),
    showCanadaProvinces: isCanada(selector(state, "addressCountryCode")),
    showStateProvince: hasStateProvince(selector(state, "addressCountryCode"))
  }
}

export default connect(mapStateToProps, {cancelAddShippingAddress})(AddShippingAddressFormContainerWithData);